import { useContext, useEffect } from 'react';

import { useFetch, GetParams } from '@uservoice/rest-utils';
import { useParams } from 'react-router-dom';

import { getTeams, Team } from '@/core/api/collections/teams';
import { EditTeams } from '@/core/users/UserPermissions/EditTeams';
import { UserEditContext } from '@/core/users/UserPermissions/UserEditContext';
import { UserPermissionTab } from '@/core/users/UserPermissions/UserPermissionsTabs';

export function UserPermissionsEditTeamsContainer () {
  const { user, updateTeam } = useContext(UserEditContext);
  const { tab } = useParams() as { tab?: UserPermissionTab };
  const [teams, loading, error, fetchTeams] = useFetch<GetParams, Team[]>(getTeams, { per_page: 100 }, { lazyFetch: true });

  const selectedTeams = {} as { [key: number]: Team | undefined };
  user?.teams.forEach(team => selectedTeams[team.id] = team);

  useEffect(() => {
    if (tab === 'teams' && !teams) {
      fetchTeams();
    }
  }, [tab]);

  return tab !== 'teams' ? null : (
    <EditTeams
      teams={teams}
      loading={loading}
      error={error}
      selectedTeams={selectedTeams}
      onChange={updateTeam}
    />
  );
}
